import {processAPIResponse} from "@/utils/request";
import {message} from "antd";
import { fetchCallsListRequest } from "@/services/api/call";
import {selectDateFilter} from "@/models/date";
import * as PreferencesSelectors from "@/selectors/preferencesSelectors"
import { FILTER_PLACES } from "@/components/Filters/LeadFilters";


const initialState = {
  callsList: {
    data: [],
    links: {},
    total: 0
  },
}
export default {
  namespace: 'call',

  state: initialState,

  effects: {

    * fetchCallsList({}, {call, put, select}) {
      const date = yield select(selectDateFilter)
            const filters = yield select(state => PreferencesSelectors.selectFilters(state, FILTER_PLACES.CALLS))
            const query = {
              branch:filters?.branch,
              from: date.start_date,
              to: date.end_date
            };
      const {response, data} = yield call(fetchCallsListRequest, {query});
      yield processAPIResponse({response, data}, {
        * onSuccess(data) {
          yield put({
            type: 'setCallsList',
            payload: data
          })
        }
        , * onError(error) {
          message.error(error?.message)
        }
      })
    }

  },
  reducers: {
    setCallsList(state, action) {
      return {
        ...state,
        callsList: action.payload
      }
    },
    reset() {
      return initialState
    }
  }
};
